// extracted by mini-css-extract-plugin
export default {"home_section":"home_home_section__17-S9","content":"home_content__o+02t"};